import React, { useRef, useEffect } from 'react'
import WheelOne from 'assets/landing/wheel1.png'
import WheelTwo from 'assets/landing/wheel2.png'
import WheelThree from 'assets/landing/wheel3.png'
import { motion, useInView, useAnimation } from 'framer-motion'
import TestimonialBox from './TestimonialBox'

const ANIMATION_VARIANTS = {
  offscreen: 'offscreen',
  onscreen: 'onscreen'
}

const TESTIMONIAL_VARIANTS = {
  [ANIMATION_VARIANTS.offscreen]: {
    x: 100,
    opacity: 0
  },
  [ANIMATION_VARIANTS.onscreen]: {
    x: 0,
    opacity: 1,
    transition: {
      type: 'easeInOut',
      bounce: 0.4,
      duration: 2
    }
  }
}
function Testimonials() {
  const ref = useRef(null)
  const controls = useAnimation()
  const isInView = useInView(ref, { once: true, threshold: 1 })

  useEffect(() => {
    if (isInView) {
      controls.start(ANIMATION_VARIANTS.onscreen)
    } else {
      controls.start(ANIMATION_VARIANTS.offscreen)
    }
  }, [isInView])

  return (
    <div ref={ref} className="testimonials">
      <motion.div className="testimonials__item" variants={TESTIMONIAL_VARIANTS} animate={controls}>
        <TestimonialBox img={WheelOne} number={1} paragraphs={2} />
      </motion.div>
      <motion.div className="testimonials__item" variants={TESTIMONIAL_VARIANTS} animate={controls}>
        <TestimonialBox img={WheelTwo} number={2} paragraphs={3} />
      </motion.div>
      <motion.div className="testimonials__item" variants={TESTIMONIAL_VARIANTS} animate={controls}>
        <TestimonialBox img={WheelThree} number={3} paragraphs={3} />
      </motion.div>
    </div>
  )
}

export default Testimonials
